<template>
  <Page title="SPPD - SPJ" :sidebar="true">
    <SideBar ref="sidebar" :value.sync="selected" @add-new="addNew" />
    <div style="padding:10px; background:white; overflow:auto">
      <!-- <Input
        type="text"
        label="Pengguna Anggaran"
        width="600px"
        :disabled="true"
        :value.sync="forms.PenggunaAnggaran"
      /> -->
      <TextArea
        label="Maksud Perjalanan Dinas"
        width="100%"
        style="height:100px"
        :disabled="true"
        :value.sync="forms.Maksud"
      />
      <Input
        type="text"
        label="Kepada"
        width="100%"
        :value.sync="forms.Kepada"
      />
      <Input
        type="text"
        label="Melalui"
        width="100%"
        :value.sync="forms.Melalui"
      />
      <!-- <Input type="text" label="Dari" width="100% " :value.sync="forms.Dari" /> -->
      <div style="display:flex">
        <Select
          label="Penandatangan"
          dbref="SPD.SelPelaksanaList"
          textKey="Nama"
          valueKey="NIP"
          width="300px"
          :value.sync="forms.NIPPenandatangan"
          :dbparams="perjalananId"
        >
          <template v-slot="{ row }">
            <div>{{ row.Nama }}</div>
          </template>
        </Select>
      </div>
      <VueEditor
        v-model="forms.Hasil"
        style="height: calc(100% - 270px)"
        :editorToolbar="[
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          [
            { align: '' },
            { align: 'center' },
            { align: 'right' },
            { align: 'justify' },
          ],
          [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ]"
      />
      <br />
      <br />
      <div style="display:flex; padding: 10px 0;" class="spj-uploader">
        <Uploader label="Foto 1" :value.sync="forms.Foto1" />
        <Uploader label="Foto 2" :value.sync="forms.Foto2" />
        <Uploader label="Foto 3" :value.sync="forms.Foto3" />
      </div>
      <div style="display:flex">
        <v-btn color="primary" @click="Save">SIMPAN</v-btn>
        <v-btn color="primary" text @click="Download">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
        <v-spacer />
        <!-- <MenuButton
          text="DOWNLOAD"
          color="success"
          :menu="['SPPD', 'Surat Tugas', 'Rincian Biaya']"
        >
        </MenuButton> -->
        <!-- <v-btn color="success" @click="Download">
          DOWNLOAD
        </v-btn> -->
      </div>
    </div>
  </Page>
</template>
<script>
import moment from 'moment'
import SideBar from './SideBar.vue'
import { VueEditor } from 'vue2-editor'

const defaultBiaya = () => [
  {
    Rincian: 'Uang harian dalam kota lebih dari 8 jam',
    Jml: 0,
    Biaya: 0,
    Total: 0,
  },
  {
    Rincian: 'Uang harian dalam daerah',
    Jml: 0,
    Biaya: 0,
    Total: 0,
  },
  {
    Rincian: 'Uang harian diklat',
    Jml: 0,
    Biaya: 0,
    Total: 0,
  },
  {
    Rincian: 'Biaya transportasi/BBM/Tol',
    Jml: 1,
    Biaya: 0,
    Total: 0,
  },
  {
    Rincian: 'Uang penginapan',
    Jml: 0,
    Biaya: 0,
    Total: 0,
  },
  {
    Rincian: 'Pengeluaran lain-lain',
    Jml: 0,
    Biaya: 0,
    Total: 0,
  },
]
const defaultForm = () => ({
  id: 0,
  PenggunaAnggaran: 'KEPALA DINAS PU',
  Maksud: '',
  TglSPT: moment().format('DD-MMM-YYYY'),
  Kendaraan: null,
  TglBerangkat: moment().format('DD-MMM-YYYY'),
  TglKembali: moment().format('DD-MMM-YYYY'),
})
export default {
  components: {
    SideBar,
    VueEditor,
  },
  data: () => ({
    selected: {},
    xmlPelaksana: [],
    xmlBiaya: defaultBiaya(),
    kegiatans: [
      {
        val: '1.03.0.00.0.00.14.01.1.05.09.5.1.2.4.1.1.01',
        txt:
          'Adm. Umum Perangkat Daerah (Sub Keg Penyelenggaraan Rapat Koordinasi Dan Konsultasi SKPD)',
      },
    ],
    forms: defaultForm(),
  }),
  computed: {
    perjalananId() {
      return { PerjalananId: this.forms.id }
    },
  },
  watch: {
    selected(val) {
      this.populate(val.id)
    },
  },
  mounted() {
    this.populate()
  },
  methods: {
    reset() {
      this.forms = defaultForm()
      this.xmlBiaya = defaultBiaya()
      this.xmlPelaksana = []
      this.selected = null
    },
    async populate(id) {
      let d = await this.$api.call('SPD.SelHasil', {
        id: id || this.forms.id,
      })
      if (d.data.length) this.forms = d.data[0]
      else this.reset()
    },
    SavePelaksana(data) {
      this.xmlPelaksana.push(data.NIP)
    },
    DeletePelaksana(idx) {
      this.xmlPelaksana.splice(idx, 1)
    },
    addNew() {
      this.reset()
    },
    async Save() {
      let d = await this.$api.call('SPD.SavHasil', {
        ...this.forms,
      })
      if (d.success) {
        this.populate(d.data.id)
        this.$refs.sidebar.rebind()
      }
    },
    Download() {
      window.open(
        this.$api.url + '/reports/sppd/doc/NOTA_DINAS/' + this.forms.id,
        '_blank'
      )
    },
  },
}
</script>
<style lang="scss">
.spj-uploader {
  .imgbox {
    width: 230px;
  }
}
</style>
